export const lastMeetingTranslation = {
  rowActions: {
    edit: 'lastmeeting-saverecordactions-edit',
    delete: 'lastmeeting-saverecordactions-delete',
    save: 'lastmeeting-saverecordactions-save',
    cancel: 'lastmeeting-saverecordactions-cancel',
  },
  infoBlock: {
    dragNDrop: 'lastmeeting-infoblock-drag-and-drop',
  },
  mainActions: {
    add: 'lastmeeting-mainactions-add',
  },
  columnHeader: {
    status: 'lastmeeting-columnheader-status',
    action: 'lastmeeting-columnheader-action',
    update: 'lastmeeting-columnheader-update',
  },
  common: {
    noData: 'lastmeeting-common-no-data',
  },
  confirmDeleteRecord: {
    content: 'lastmeeting-confirmdeleterecord-content',
    title: 'lastmeeting-confirmdeleterecord-title',
    confirmBtn: 'lastmeeting-confirmdeleterecord-confirm-btn',
    rejectBtn: 'lastmeeting-confirmdeleterecord-reject-btn',
  },
}
